angular.module('eclipseApp.core').controller('checkoutChangeInternetCtrl', ['$scope', 'accountDashboardManager', '$state', 'commonService', function($scope, accountDashboardManager, $state, commonService){
  console.log('checkoutChangeInternet LOADED!');

  var _self = {};
  $scope.orderDetails = {};

  _self.stateConfirmation = 'myAccount.internet.package.change.confirmation';
  _self.stateReview = 'myAccount.internet.package.change.review';

  // init session
  if (!accountDashboardManager.getSession('checkoutSession')) {
    accountDashboardManager.setSession('checkoutSession', accountDashboardManager.checkoutSession);
  }

  $scope.orderDetails.accountNumber = commonService.internetAccountNumber;


  $scope.$on('$stateChangeStart', function(evt, toState, toParams, fromState, fromParams){

    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: fromState', fromState);
    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: toState', toState);
    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: fromParams', fromParams);
    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: toParams', toParams);
    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: state.includes', $state.includes('myAccount.internet.package'));
    console.log('@checkoutChangeInternetCtrl:$on.$stateChangeStart: step complete', accountDashboardManager.checkoutSession.confirmation.complete);

    if (accountDashboardManager.checkoutSession.confirmation.complete &&
        accountDashboardManager.checkoutSession.review.complete) {
      if (fromState.name === _self.stateConfirmation &&
          toState.name === _self.stateReview ) {

        evt.preventDefault();
        accountDashboardManager.cleanCheckoutSession();
        accountDashboardManager.resetCheckoutSession();
        $state.go('home');

      }
      else if (fromState.name === _self.stateConfirmation &&
              toState.name !== _self.stateReview) {

        accountDashboardManager.cleanCheckoutSession();
        accountDashboardManager.resetCheckoutSession()
      }
    }

  });
  $scope.$on('$stateChangeSuccess', function(evt, toState, toParams, fromState, fromParams){
  });
  $scope.$on('$stateChangeError', function(evt, toState, toParams, fromState, fromParams){
  });

}]);
